<cigna-skeleton
  *ngIf="
    lastName === '' || (!isOhpUser && profileLinks.length === 0);
    else utilUser
  "
  repeat="1"
  layout="10"
  class="nav-skeleton"
>
</cigna-skeleton>

<ng-template #utilUser>
  <div class="util-user" data-test="profile-nav">
    <div>
      <cigna-icon type="profile-head" class="util-user__img"></cigna-icon>
    </div>

    <span class="util-user__name" data-test="header-user-name"
      >{{ firstName }} {{ lastName }}</span
    >
    <cigna-icon type="caret-down" class="util-dropdown"></cigna-icon>

    <div class="util-user__links">
      <div class="util-user__link-item">
        Signed in as (<span cg-test="userid" data-test="header-user-id">{{
          userid
        }}</span
        >)
      </div>

      <ng-container *ngFor="let link of profileLinks">
        <div
          class="util-user__link-item"
          *ngIf="!link.openExternal; else externalLink"
        >
          <a
            [href]="link.path"
            [routerLink]="link.path"
            [class.cg-disabled-link]="impersonator && !link.allowImpersonator"
            [class.cg-non-clickable]="impersonator && !link.allowImpersonator"
            [attr.data-test]="'profile-nav-child-' + link.identifier"
            [cignaTrackClicks]="[
              'trackEventOther',
              link.title,
              'ac-NV002-Name Subnav',
              { prop20: 'nav-sub-utility' }
            ]"
            >{{ link.title }}</a
          >
        </div>

        <ng-template #externalLink>
          <div class="util-user__link-item">
            <a
              [href]="link.path"
              target="_blank"
              rel="noopener noreferrer"
              [class.cg-disabled-link]="impersonator && !link.allowImpersonator"
              [class.cg-non-clickable]="impersonator && !link.allowImpersonator"
              [attr.data-test]="'profile-nav-child-' + link.identifier"
              [cignaTrackClicks]="[
                'trackEventOther',
                link.title,
                'ac-NV002-Name Subnav',
                { prop20: 'nav-sub-utility' }
              ]"
              >{{ link.title }}
              <cigna-icon
                type="external-link"
                class="cg-mat-icon-link-right cg-color-digital-blue"
                [class.cg-disabled-link]="
                  impersonator && !link.allowImpersonator
                "
              ></cigna-icon>
            </a></div
        ></ng-template>
      </ng-container>
      <div class="util-user__link-item">
        <a
          [href]="inboxUrl"
          target="_blank"
          rel="noopener noreferrer"
          [class.cg-disabled-link]="impersonator"
          [class.cg-non-clickable]="impersonator"
          [attr.data-test]="'profile-nav-child-inbox'"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Inbox',
            'ac-NV002-Name Subnav',
            { prop20: 'nav-sub-utility' }
          ]"
          >Inbox
          <cigna-icon
            type="external-link"
            class="cg-mat-icon-link-right cg-color-digital-blue"
            [class.cg-disabled-link]="impersonator"
          ></cigna-icon>
        </a>
      </div>
      <div class="util-user__link-item" *ngIf="hasMessageCenterFunction">
        <a
          routerLink="/message-center"
          [attr.data-test]="'profile-nav-child-mcenter'"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Message Center',
            'ac-NV002-Name Subnav',
            { prop20: 'nav-sub-utility' }
          ]"
          >Message Center</a
        >
      </div>
    </div>
  </div>
</ng-template>
